import { saveAs } from "file-saver";
import api from "../Services/api";

const decodeBase64Pdf = (base64) => {
  const cleaned = String(base64 || "")
    .replace(/^data:application\/pdf;base64,/i, "")
    .trim();
  if (!cleaned) return null;
  const binary = atob(cleaned);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: "application/pdf" });
};

/**
 * Downloads QuestPDF comprovante (new model) for a PIX payment or lote.
 * Prefers stored `receipt_pdf_base64` when already in memory; otherwise hits IB receipt endpoints.
 */
export const downloadPixReceiptPdf = async ({
  receiptPdfBase64,
  paymentId,
  batchId,
  accountId,
  fileName,
} = {}) => {
  const fromBase64 = decodeBase64Pdf(receiptPdfBase64);
  if (fromBase64) {
    saveAs(fromBase64, fileName || "comprovante-pix.pdf");
    return { success: true };
  }

  const batch = String(batchId || "").trim();
  const payment = String(paymentId || "").trim();
  if (!batch && !payment) {
    return { success: false, message: "Comprovante indisponível para esta transação." };
  }

  const path = batch
    ? `/v1/ib/pix/batches/${encodeURIComponent(batch)}/receipt`
    : `/v1/ib/pix/${encodeURIComponent(payment)}/receipt`;

  const params = {};
  if (accountId) params.account_id = accountId;

  const res = await api.get(path, {
    params,
    responseType: "blob",
  });

  const blob = new Blob([res.data], { type: "application/pdf" });
  const name =
    fileName
    || (batch ? `comprovante-pix-lote-${batch}.pdf` : `comprovante-pix-${payment}.pdf`);
  saveAs(blob, name);
  return { success: true };
};
